<template>
    <div class="qualify-sidebar-input-container">
        <label class="sidebar-input-label" :class="brandColor" v-if="label">
            <span v-html="label"></span>
            <template v-if="isMandatory">
                ({{ $t('mandatory') }})
            </template>
        </label>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'QualifySidebarInputContainer',
        props: {
            label: {
                type: String,
                default: null
            },
            isMandatory: {
                type: Boolean,
                default: false
            },
        },
    };
</script>

<style lang="scss">
.qualify-sidebar-input-container {
    margin-bottom: 40px;

    &:last-child {
        margin-bottom: 0;
    }

    &.no-bottom-margin {
        margin-bottom: 15px;
    }

    .sidebar-input-label {
        display: block;
        padding-bottom: 15px;

        span {
            display: block;
            font-size: 16px;
            line-height: 1.4;
            font-weight: 700;
            letter-spacing: 1.11px;
            text-transform: uppercase;

            @media #{$mq_phone} {
                font-size: 15px;
            }
        }
    }
}
</style>